<script>
import PopUp from '@/components/PopUp.vue'
import SelectImage from '@/views/Admin/Public/SelectImage.vue'
import MenuUnderline from '@/views/Admin/Public/MenuUnderline.vue'
export default {
    components: { PopUp, SelectImage, MenuUnderline },
    props: ['availableBookings', 'publicPage', 'selectedTab', 'customTabs', 'bookingItem', 'selectedCustomTab', 'inMenuEditMode','hasChanges','backgroundColor','publicPageImages','courses','courseInstructors', 'publicPageColors'],
    emits: ['update:hasChanges', 'update:selectedCustomTab','update:selectedTab','update:bookingItem', 'update:inMenuEditMode', 'update:customTabs'],
    created() {    
        
    },
    data() {
        return {  
            tabPrevName: null,
            editNameTab: null
        }
    }, 
    methods:
    {
        selectCustomTab(tab)
        {
            this.$emit('update:selectedCustomTab', tab);          
            this.$emit('update:selectedTab', 'customTab');
        },
        showBooking(bookingItem)
        {   
            this.$emit('update:bookingItem', bookingItem);
            this.$emit('update:selectedTab', 'bokning');          
        },
        selectTab(linkName)
        {
            this.$emit('update:bookingItem', null);
            this.$emit('update:selectedTab', linkName);
        },
        changeToEditMode(mode)
        {
            this.$emit('update:inMenuEditMode', mode);
            
        },
        removeTab(id)
        {
            this.$emit('update:hasChanges', true);       
            var tabs = this.customTabs.filter(x => x.id != id);
            this.$emit('update:customTabs', tabs);       
        },
        addTab(){
            this.editNameTab = { id: 0, name: null };
        },
        addLogo(){
            
        },
        addTabToCustomTabs() {
            this.customTabs.push(this.editNameTab);
            this.editNameTab = null;
        },
        changeNameOnCustomTab(tab) {
            this.tabPrevName = tab.name;
            this.editNameTab = tab;
        },
        cancelNameOnCustomTab() {
            this.editNameTab.name = this.tabPrevName;
            this.editNameTab = null;
        },
        getSelectedStyle(showStyle) {
        return showStyle ?
          this.backgroundColor
         : null;
        }
    }
}
</script>
<template>
   <div class="Menu-menu">                                 
        <div class="nav" v-if="!inMenuEditMode">                               
            <div @click="selectTab('hem')">
                <h3> Hem </h3>
                <MenuUnderline :backgroundColor="getSelectedStyle(selectedTab == 'hem')"></MenuUnderline>
                </div>
            <div @click="selectTab('foreningen')">
                <h3>{{this.$store.state.settings.Community.singular}}</h3> 
                <MenuUnderline :backgroundColor="getSelectedStyle(selectedTab == 'foreningen')"></MenuUnderline>
            </div>
            <div v-for="tab in customTabs">
                <h3 @click="selectCustomTab(tab)"> {{ tab.name }}</h3>
                <MenuUnderline :backgroundColor="getSelectedStyle( selectedTab == 'customTab' && selectedCustomTab.name == tab.name)"></MenuUnderline>               
            </div>
            <div v-if="publicPage.include_image_gallery" @click="selectTab('bildgalleriet')">
                <h3>{{this.$store.state.settings.ImageGallery.singular}}  </h3>
                <MenuUnderline :backgroundColor="getSelectedStyle(selectedTab == 'bildgalleriet')"></MenuUnderline>               
            </div>
            <div v-if="availableBookings.length == 1" @click="showBooking(availableBookings[0])">
                <h3>{{ availableBookings[0].name }}</h3>                               
                <MenuUnderline :backgroundColor="getSelectedStyle(selectedTab == 'bokning')"></MenuUnderline>               
            </div>                 
            <div v-if="availableBookings.length > 1" @click="selectTab('bokning')">              
                <h3>{{this.$store.state.settings.BookingItem.plural}}</h3>                             
                <MenuUnderline :backgroundColor="getSelectedStyle(selectedTab == 'bokning')"></MenuUnderline>               
            </div>           
            <div v-if="courses.length > 0" @click="selectTab('kurser')">              
                <h3>{{this.$store.state.settings.Course.plural}}</h3>                             
                <MenuUnderline :backgroundColor="getSelectedStyle(selectedTab == 'kurser')"></MenuUnderline>               
            </div>                 
            <div v-if="courseInstructors.length > 0" @click="selectTab('instruktörer')">              
                <h3>{{this.$store.state.settings.CourseInstructor.plural}}</h3>                             
                <MenuUnderline :backgroundColor="getSelectedStyle(selectedTab == 'instruktörer')"></MenuUnderline>               
            </div>                 
            <div v-if="publicPage.include_contact" @click="selectTab('kontakt')">
                <h3>Kontakt</h3>
                <MenuUnderline :backgroundColor="getSelectedStyle(selectedTab == 'kontakt')"></MenuUnderline>               
            </div>   
              <button class="btn" style="position:absolute; right: 0px; border-radius:3px; top: 2px;" @click="changeToEditMode(true)" v-tooltip="'Redigera menyn'">
                Redigera menyn
            </button>                
        </div>
        <div class="nav" v-else style="border: 1px dashed #a5a5a5; background-color: rgba(142, 140, 140,0.6)">  
            <div style="position:absolute; left: 50px; top: 2px;">
                <SelectImage :publicPageImages="publicPageImages" :location="'logo'" :isLogo="true"></SelectImage>  
            </div> 
                                 
            <div>
                <h3> Hem </h3>
            </div>
            <div><h3>{{this.$store.state.settings.Community.singular}}</h3></div>
            <div v-for="tab in customTabs" class="menu-tabs">
                <h3> {{ tab.name }}</h3>           
                &nbsp;<i class="fa-solid fa-trash" @click="removeTab(tab.id)" v-tooltip="'Ta bort fliken'"></i>
                &nbsp;<i class="fa-solid fa-pen" @click="changeNameOnCustomTab(tab)" v-tooltip="'Byt namn på fliken'"></i>
            </div>
            <button class="btn" @click="addTab()" v-tooltip="'Lägg till ny Flik'"> 
                <i class="fa-solid fa-plus"></i>
            </button>
            <div>
                <h3 :style="{'opacity': publicPage.include_image_gallery ? '1' : '0.4'}">{{this.$store.state.settings.ImageGallery.singular}}</h3> 
                &nbsp;<i v-if="!publicPage.include_image_gallery" class="fa-solid fa-eye-slash" @click="publicPage.include_image_gallery = true" v-tooltip="'Bildgalleriet är dold i menyn. Klicka här för att göra det synligt'"></i>
                &nbsp;<i  v-else class="fa-solid fa-eye menu-show-section-icon" @click="publicPage.include_image_gallery = false" v-tooltip="'Dölj Bildgalleriet'"></i>
            </div>
            <div v-if="availableBookings.length == 1">
                <h3>{{ availableBookings[0].name }}</h3>                               
            </div>                 
            <div v-if="availableBookings.length > 1">    
                <h3>{{this.$store.state.settings.BookingItem.plural}}</h3>                            
            </div>                                          
            <div v-if="courses.length > 0">    
                <h3>{{this.$store.state.settings.Course.plural}}</h3>                            
            </div>  
            <div v-if="courseInstructors.length > 0">              
                <h3>{{this.$store.state.settings.CourseInstructor.plural}}</h3>
            </div>                  
            <div >
                <h3 :style="{'opacity': publicPage.include_contact ? '1' : '0.4'}">Kontakt</h3>
                &nbsp;<i v-if="!publicPage.include_contact" class="fa-solid fa-eye-slash" @click="publicPage.include_contact = true" v-tooltip="'Kontaktfliken är dold i menyn. Klicka här för att göra den synligt'"></i>
                &nbsp;<i  v-else class="fa-solid fa-eye menu-show-section-icon" @click="publicPage.include_contact = false" v-tooltip="'Dölj Kontaktfliken'"></i>
            </div> 
            <button class="btn" @click="changeToEditMode(false)" v-tooltip="'Stäng redigeringsmenyn'" style="position:absolute; right: 0px;">
                    <i class="fa-solid fa-xmark"></i>
                </button>              
        </div>
    </div>

    <PopUp v-if="editNameTab" :bgColor="'rgba(250, 233, 197, 0.92)'">
        <h2 v-if="editNameTab.id != 0">Byt Namn på fliken</h2>     
        <h2 v-if="editNameTab.id == 0">Välj Namn på fliken</h2>     
        <input type="text" v-model="editNameTab.name" />
        <br><br>
        <button class="btn btn-gray float-right" @click="cancelNameOnCustomTab()">Avbryt</button>
        <button class="btn float-right" v-if="editNameTab.id != 0" @click="editNameTab = null">Klar</button>
        <button class="btn float-right" v-if="editNameTab.id == 0" @click="addTabToCustomTabs()">Klar</button>
    </PopUp>
</template>

<style scoped>
    .Menu-menu
    {
        width:100%; 
        color: rgb(144, 142, 142);
        z-index: 1;
    }

    .Menu-edit-menu 
    {
        font-size: 13px;
        font-weight: 600;
    }

    .Menu-edit-menu .btn {
        border-radius: 3px;
        margin: 0px;
    }
    
    .nav{
        font-size: 14px;
        margin: auto;
        display: flex;
        justify-content: center;
        font-size: 9pt;
        position: relative;
        top: 42px;
        z-index: 1;
        padding-bottom: 2px;
    }

    .nav h3 {
        margin-bottom: 4px;
    }
    
    h3 {
        text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
        display: inline-block;
        color: white;
    }
    .nav div{
        cursor: pointer;
        text-align: center;
        vertical-align: top;
        padding: 0px 15px;
    }

    .btn {
        border-radius: 3px;
        margin-top: 2px;
    }

    .menu-tabs i, .menu-show-section-icon {
        color: white;
         text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
    }

</style>